module.exports = __webpack_public_path__ + "media/images/approach-segment-777c89aacd3b92a0b21ad4da8e84c7ab.jpg";